import { render, staticRenderFns } from "./adminMenu.vue?vue&type=template&id=5340c952"
import script from "./adminMenu.vue?vue&type=script&lang=js"
export * from "./adminMenu.vue?vue&type=script&lang=js"
import style0 from "./adminMenu.vue?vue&type=style&index=0&id=5340c952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VSpacer,VToolbar})
